import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';

<template>
  {{pageTitle (t "common.strategy_finder.default")}}
  {{outlet}}
</template>
